import React from 'react';
import { Helmet } from 'react-helmet';

const Enquiry = () => {
    const onSubmit = (event) => {
        event.preventDefault();

        const form = event.target;

        const name = form.name.value;
        const email = form.email.value;
        const phone = form.phone.value;
        const days = form.days.value;
        const pickUpPoint = form.pick_up_point.value;
        const cab = form.Cab.value;
        const date = form.date.value;

        const whatsappMessage = `
Hello, I would like to make an enquiry.

Name: ${name}
Email: ${email}
Phone: ${phone}
Number of Days: ${days}
Pick Up Point: ${pickUpPoint}
Selected Cab: ${cab}
Date of Journey: ${date}
`;

        const encodedMessage = encodeURIComponent(whatsappMessage.trim());
        const whatsappNumber = "917507048333"; 
        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

        window.open(whatsappURL, "_blank");
    };

    return (
        <div>


            
            <Helmet>
                <title>Enquiry | Platinum24 Cabs</title>
            </Helmet>
 <div
      className="breadcumb-wrapper"
      // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Enquiry</h1>
          <div className="breadcumb-menu-wrap">
          </div>
        </div>
      </div>
    </div>
     
            {/* Form Section */}
            <section className="news-details-section fix section-padding">
                <div className="container">
                    <div className="row container">
                        <div className="col-12">
                            <div className="row">
                                <div className="de-item-list mb30">
                                    <h3 className="text-white">Do you have any enquiry?</h3>
                                    <form
                                        name="contactForm"
                                        id="contact_form"
                                        className="form-border"
                                        onSubmit={onSubmit}
                                    >
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="name" className="text-dark small textt">Your Full Name</label>
                                                <input name="name" id="name" className="form-control form-control-lg rounded-0" placeholder="Your Full Name" required />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="email" className="text-dark small textt">Your Email</label>
                                                <input type="email" name="email" id="email" className="form-control form-control-lg rounded-0" placeholder="Your Email" required />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="phone" className="text-dark small textt">Your Phone</label>
                                                <input type="tel" name="phone" id="phone" className="form-control form-control-lg rounded-0" placeholder="Your Phone" required />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="days" className="text-dark small textt">Number of Days</label>
                                                <input type="number" name="days" id="days" className="form-control form-control-lg rounded-0" placeholder="Number of Days" required min="1" max="100" />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="pick_up_point" className="text-dark small textt">Pick Up Point</label>
                                                <input name="pick_up_point" id="pick_up_point" className="form-control form-control-lg rounded-0" placeholder="Pick Up Point" required />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="Cab" className="text-dark small textt">Select Cabs</label>
                                                <select name="Cab" id="Cab" className="border py-2 form-control form-control-lg rounded-0" required>
                                                    <option value="" disabled>Select Cabs</option>
                                                    <option value="Swift Dzire (4 + 1 Seater)">Swift Dzire (4 + 1 Seater)</option>
                                                    <option value="Kia Carens (6 + 1 Seater)">Kia Carens (6 + 1 Seater)</option>
                                                    <option value="Ertiga (6 + 1 Seater)">Ertiga (6 + 1 Seater)</option>
                                                    <option value="Tavera (6 + 1 Seater)">Tavera (6 + 1 Seater)</option>
                                                    <option value="Innova (6 + 1 Seater)">Innova (6 + 1 Seater)</option>
                                                    <option value="Innova Crysta (6 + 1 Seater)">Innova Crysta (6 + 1 Seater)</option>
                                                    <option value="13 Seater">13 Seater</option>
                                                    <option value="17 Seater">17 Seater</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="date" className="text-dark small textt">Date of Journey</label>
                                                <input type="date" name="date" id="date" className="form-control form-control-lg rounded-0" required />
                                            </div>

                                          
                                        </div>

                                        <div className="text-center py-3">
                                            <button type="submit" className="btn-main mt-2 py-2 px-4 border-0">
                                                Submit on WhatsApp
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Enquiry;
